import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FetcherService } from './fetcher/fetcher.service';
import { GetCategoryPageContentResponsePayload } from '@cpak/adp-cpak-bff-service-models';

@Injectable({
  providedIn: 'root',
})
export class CategoryTreeDataService {
  public constructor(private readonly http: FetcherService) {}

  public getCategoryTreeData(plant: string): Observable<GetCategoryPageContentResponsePayload | null> {
    return this.http.get<GetCategoryPageContentResponsePayload>(`/api/pages/catalog/categories`, {
      plant,
    });
  }
}
